import { render, staticRenderFns } from "./HomeDetails.vue?vue&type=template&id=d17f18b8&scoped=true&"
import script from "./HomeDetails.vue?vue&type=script&lang=js&"
export * from "./HomeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17f18b8",
  null
  
)

component.options.__file = "HomeDetails.vue"
export default component.exports